import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-cyan-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/25f404a5410cc1643f0ecf304a93d353/566e9f0a43c3e58f8ab24bb5a270dcb4.png" 
              alt="YEZ Laundry" 
              className="h-12 w-12 rounded-full object-cover mb-4"
            />
            <p className="text-white/90 text-sm leading-relaxed mb-4">
              Solusi laundry profesional yang mengutamakan kebersihan, ketelitian, dan kepuasan pelanggan. Kami hadir untuk memudahkan hidup Anda dengan layanan laundry berkualitas tinggi.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://wa.me/62895338139977"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/yezlaundry"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/yezlaundry"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Menu</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white text-sm transition-colors">
                  Beranda
                </Link>
              </li>
              <li>
                <Link to="/tentang-kami" className="text-white/80 hover:text-white text-sm transition-colors">
                  Tentang Kami
                </Link>
              </li>
              <li>
                <Link to="/layanan" className="text-white/80 hover:text-white text-sm transition-colors">
                  Layanan
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Kontak</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line mt-1 mr-2 text-white/80"></i>
                <span className="text-white/80">Brajan, Pugeran, Kec. Karangdowo, Kabupaten Klaten, Jawa Tengah 57464</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 text-white/80"></i>
                <a href="tel:+62895338139977" className="text-white/80 hover:text-white transition-colors">
                  0895-3381-3997-7
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2 text-white/80"></i>
                <a href="mailto:yezlaundry@gmail.com" className="text-white/80 hover:text-white transition-colors">
                  yezlaundry@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-6 text-center">
          <p className="text-white/70 text-sm">
            © {currentYear} YEZ Laundry. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
